import { DATE_FORMAT_MMDDYYYY } from '@gripp/shared-logic';
import { t } from 'i18next';
import { StyleProp, View, ViewStyle } from 'react-native';
import { DatePickerSelector } from './datePickerSelector';
import { datePickerStyle as styles } from './datePickerStyle';

export type DateRangeSelectorProps = {
  control: any;
  setValue: any;
  startDateName?: string;
  endDateName?: string;
  mode?: 'date' | 'time' | 'datetime';
  labelStart?: string;
  labelEnd?: string;
  maxYears?: number;
  minDate?: string;
  styleContainer?: StyleProp<ViewStyle>;
};

export const DateRangeSelector = (props: DateRangeSelectorProps) => (
  <View style={[styles.dateRangeContainer, props?.styleContainer]}>
    <DatePickerSelector
      control={props.control}
      setValue={props.setValue}
      name={props?.startDateName ?? 'startDate'}
      placeholder={props.mode === 'time' ? '00:00' : DATE_FORMAT_MMDDYYYY}
      label={props?.labelStart ?? t('activity.filter.from')}
      height={20}
      isStartDate
      mode={props?.mode ?? 'date'}
      maxYears={props.maxYears}
      minDate={props.minDate}
    />
    <DatePickerSelector
      control={props.control}
      setValue={props.setValue}
      name={props?.endDateName ?? 'endDate'}
      placeholder={props.mode === 'time' ? '00:00' : DATE_FORMAT_MMDDYYYY}
      label={props?.labelEnd ?? t('activity.filter.to')}
      height={20}
      mode={props?.mode ?? 'date'}
      maxYears={props.maxYears}
      minDate={props.minDate}
    />
  </View>
);
